import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import de from "./locales/de.json";
import en from "./locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { de: { translation: de }, en: { translation: en } },
    fallbackLng: "de",
    supportedLngs: ["de", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "studioops_lang",
    },
  });

if (typeof document !== "undefined") {
  const setLang = (lng) => { document.documentElement.lang = (lng || "de").slice(0, 2); };
  setLang(i18n.language);
  i18n.on("languageChanged", setLang);
}

export default i18n;
